import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Text, Title } from '@tremor/react';
import type { DviInspection, ServiceOrder } from '../../api/types';
import { fetchDviRecent } from '../../api/dvi';
import DviRecentList from '../dvi/DviRecentList';
import { t } from '../../lib/i18n';

export default function Dvi({ orders, sid }: { orders: ServiceOrder[]; sid: number | null }) {
  const nav = useNavigate();
  const [rows, setRows] = useState<DviInspection[] | null>(null);
  const [picking, setPicking] = useState(false);
  const c = t.dvi;

  useEffect(() => {
    let a = true;
    fetchDviRecent(sid).then((r) => a && setRows(r)).catch(() => a && setRows([]));
    return () => { a = false; };
  }, [sid]);

  const wos = useMemo(() => [...new Map(orders.map((o) => [`${o.sid}-${o.tnum}`, o])).values()].slice(0, 60), [orders]);

  return (
    <Card>
      <div className="flex items-center justify-between mb-3">
        <Title className="text-base">{c.title}</Title>
        <Button size="xs" onClick={() => setPicking((p) => !p)}>{c.newInspection}</Button>
      </div>

      {picking && (
        <Card className="mb-3">
          <Text className="text-sm mb-2">{c.pickWo}</Text>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {wos.map((o) => (
              <button key={`${o.sid}-${o.tnum}`} className="text-left text-sm underline"
                onClick={() => nav(`/dvi/captura/${o.sid}/${o.tnum}`, { state: { equip: o.equip_id } })}>
                #{o.tnum} · {o.anum_name}
              </button>
            ))}
          </div>
        </Card>
      )}

      <DviRecentList rows={rows} />
    </Card>
  );
}
